<template>
  <div class="aim-page">
    <!-- 模块1：Banner -->
    <section class="banner-section">
      <div class="banner-bg">
        <img src="/banner-AI营销背景图.jpg" alt="" class="banner-bg-img" />
      </div>
      <div class="container-responsive banner-container">
        <div class="banner-grid">
          <AnimatedSection>
            <div class="banner-text">
              <h1 class="banner-title">AI效果营销</h1>
              <h2 class="banner-subtitle">驱动全域商业增长</h2>
              <p class="banner-desc">
                以AI技术为核心，覆盖从获客到转化的全链路营销，按效果付费模式，助力品牌实现精准触达、规模化获客与私域精细化运营。
              </p>
              <a href="javascript:void(0)" class="cta-btn" @click="openContact">
                <span class="cta-btn-text">立即咨询合作</span>
                <LucideIcon name="arrow-right" :size="16" class="cta-btn-arrow" />
              </a>
            </div>
          </AnimatedSection>
          <AnimatedSection :delay="200">
            <div class="banner-image-wrap">
              <img src="/banner-AI营销右边图.png" alt="AI效果营销 配图" class="banner-image" />
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>

    <!-- 模块2：四大AI场景能力矩阵 -->
    <section class="matrix-section">
      <div class="container-responsive">
        <AnimatedSection>
          <div class="section-head">
            <h2 class="section-title">四大AI场景能力矩阵</h2>
            <p class="section-desc">
              覆盖从公域获客到私域运营的全链路，企业可按需组合，实现按效果付费的确定性增长
            </p>
          </div>
        </AnimatedSection>
        <div class="matrix-grid">
          <AnimatedSection v-for="(item, i) in challenges" :key="i" :delay="i * 100">
            <div class="matrix-card">
              <div class="matrix-text">
                <h3 class="matrix-title">{{ item.title }}</h3>
                <p class="matrix-desc">{{ item.desc }}</p>
                <div class="matrix-tags">
                  <span v-for="(tag, j) in item.tags" :key="j" class="matrix-tag">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0a0a0a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M5 13l4 4L19 7" />
                    </svg>
                    {{ tag }}
                  </span>
                </div>
              </div>
              <div class="matrix-image-wrap">
                <div class="matrix-image-box">
                  <img :src="item.image" :alt="item.title" />
                </div>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>

    <!-- 模块3：解决方案详情 -->
    <section class="solution-section">
      <div class="container-responsive">
        <div
          v-for="(sol, si) in solutions"
          :key="si"
          class="solution-block"
          :class="{ 'solution-block-last': si === solutions.length - 1 }"
        >
          <AnimatedSection>
            <div class="solution-head">
              <div>
                <h2 class="solution-title">{{ sol.title }}</h2>
                <p class="solution-desc">{{ sol.desc }}</p>
              </div>
              <div class="solution-stats">
                <div v-for="(st, i) in sol.stats" :key="i">
                  <div class="solution-stat-value" :style="{ color: sol.color }">{{ st.value }}</div>
                  <div class="solution-stat-label">{{ st.label }}</div>
                </div>
              </div>
            </div>
          </AnimatedSection>

          <div class="feature-grid">
            <AnimatedSection v-for="(f, i) in sol.features" :key="i" :delay="i * 80">
              <div class="feature-card">
                <LucideIcon
                  :name="f.icon"
                  :size="20"
                  :stroke-width="2"
                  class="feature-icon"
                  :style="{ color: sol.color }"
                />
                <div class="feature-text">
                  <h3>{{ f.title }}</h3>
                  <p>{{ f.desc }}</p>
                </div>
              </div>
            </AnimatedSection>
          </div>

          <div v-if="sol.channels" class="channel-grid">
            <AnimatedSection v-for="(ch, i) in sol.channels" :key="i" :delay="i * 100">
              <div class="channel-card" :style="{ background: ch.bg }">
                <div class="channel-head">
                  <img :src="ch.image" :alt="ch.name" />
                  <h3>{{ ch.title }}</h3>
                </div>
                <p>{{ ch.desc }}</p>
              </div>
            </AnimatedSection>
          </div>

          <AnimatedSection>
            <div class="case-card">
              <div class="case-image-wrap">
                <img :src="sol.caseStudy.image" :alt="sol.caseStudy.alt" />
              </div>
              <div class="case-body">
                <h3 class="case-label">客户案例</h3>
                <div class="case-main">
                  <h4 class="case-title">{{ sol.caseStudy.title }}</h4>
                  <p class="case-desc">{{ sol.caseStudy.desc }}</p>
                </div>
                <div class="case-stats">
                  <div v-for="(cs, i) in sol.caseStudy.stats" :key="i">
                    <span class="case-stat-value">{{ cs.value }}</span><span class="case-stat-label">{{ cs.label }}</span>
                  </div>
                </div>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>

    <!-- 模块10：CTA -->
    <section class="cta-section">
      <div class="cta-bg">
        <img src="/底部背景AI效果营销.jpg" alt="" class="cta-bg-img" />
      </div>
      <div class="container-responsive cta-content">
        <AnimatedSection>
          <h2 class="cta-title">开启AI营销升级之旅</h2>
          <p class="cta-desc">
            专业团队为您定制专属AI效果营销方案，按效果付费，让每一分投入都有回报
          </p>
          <div class="cta-btn-wrap">
            <a href="javascript:void(0)" class="cta-btn cta-btn-lg" @click="openContact">
              <span class="cta-btn-text">立即咨询合作</span>
              <LucideIcon name="arrow-right" :size="16" class="cta-btn-arrow" />
            </a>
          </div>
        </AnimatedSection>
      </div>
    </section>
  </div>
</template>

<script>
import AnimatedSection from '@/components/AnimatedSection.vue'
import LucideIcon from '@/components/LucideIcon.vue'

export default {
  name: 'AiMarketingContent',
  components: { AnimatedSection, LucideIcon },
  data() {
    return {
      // 四大AI场景能力矩阵
      challenges: [
        {
          title: 'AI获客',
          desc: '精准触达，规模化获客，公私域闭环',
          tags: ['字节AI获客', '京东AI获客'],
          image: '/AI效果营销-AI获客.jpg'
        },
        {
          title: 'AI国补',
          desc: '一站式国补开单服务，全流程闭环',
          tags: ['极速入驻', '智能开单'],
          image: '/AI效果营销-AI国补.jpg'
        },
        {
          title: 'AI直播',
          desc: '数字人直播，智能内容生成，一键分发',
          tags: ['中央直播', '多店联播'],
          image: '/AI效果营销-AI直播.jpg'
        },
        {
          title: 'AI社群',
          desc: 'AI社群机器人+SaaS工具，精细化运营',
          tags: ['智能客服', '自动卖货'],
          image: '/AI效果营销-AI社群.jpg'
        }
      ],
      // 解决方案详情（AI 获客 / AI 国补 / AI 直播 / AI 社群）
      solutions: [
        {
          title: 'AI 获客',
          color: '#FF6B35',
          desc: 'AI 智能语音机器人，7×24 小时规模化触达，依托大模型意向识别算法精准筛选意向用户，完成从公域触达到私域留存的无缝闭环，助力品牌高效获取潜客。',
          stats: [
            { value: '全天候', label: '智能服务' },
            { value: '8大', label: '行业覆盖' },
            { value: '100+', label: '品牌合作' }
          ],
          features: [
            { icon: 'target', title: '智能触达', desc: 'AI 语音机器人全天候外呼，大模型意向识别' },
            { icon: 'users', title: '多场景加微', desc: 'AI 外呼+v、短信+v、视频+v，适配不同客群' },
            { icon: 'route', title: '公域潜客挖掘', desc: '圈选目标客群主动触达，加微率更高' },
            { icon: 'shield-check', title: '合规安全体系', desc: '事前审核、事中风控、事后质检全流程覆盖' }
          ],
          channels: [
            {
              image: '/抖音.png',
              name: '抖音',
              title: '字节 AI 获客',
              bg: 'linear-gradient(to bottom, #F3E8FF 0%, #ffffff 100%)',
              desc: '即开即用，抖音官方通道合规触达。为抖音电商打造的 AI 智能外呼工具，打通官方订单回访系统，实现公域流量向企微私域的高效转化。'
            },
            {
              image: '/京东.png',
              name: '京东',
              title: '京东 AI 获客',
              bg: 'linear-gradient(to bottom, #FEE2E2 0%, #ffffff 100%)',
              desc: '京东企微背书，多平台合规体系。调用京东 / 字节 / 天猫 / 小红书数据，京东企微官方账号归属，用户更信赖，覆盖多平台电商生态。'
            }
          ],
          caseStudy: {
            image: '/AI营销-客户案例-AI 获客.jpg',
            alt: 'AI获客客户案例',
            title: '大健康类品牌（健康 / 保健品）',
            desc: '通过AI获客外呼触达营销整体方案，实现规模化精准触达，意向客户转化率显著提升。',
            stats: [
              { value: '5倍', label: '利润提升' },
              { value: '100+', label: 'ROI' }
            ]
          }
        },
        {
          title: 'AI 国补',
          color: '#06B4D8',
          desc: '一站式国补开单服务，覆盖极速入驻、智能开单、AI 资料核销、全流程培训支持。针对家电、3C 数码零售门店，解决国补政策落地难、流程复杂的痛点，按开单金额2.5%收费（利润率1%）。',
          stats: [
            { value: 'T+3', label: '快速结算' },
            { value: '2.5%', label: '服务费率' },
            { value: '全流程', label: '培训支持' }
          ],
          features: [
            { icon: 'zap', title: '极速入驻', desc: '扫码注册→国补报名→审核建群→邮件开通，线上快速办理' },
            { icon: 'file-check', title: '智能开单', desc: '筛选国补商品、自动计算金额、SN 码校验、订单全流程管理' },
            { icon: 'calculator', title: 'AI 资料核销', desc: '核销资料实时上传建行，系统直联，T+3 结算，防止丢失' },
            { icon: 'users', title: '全流程培训支持', desc: '政策培训、审计要点、系统操作、日常答疑、配合商务局复审' }
          ],
          caseStudy: {
            image: '/AI营销-客户案例-AI 国补.jpg',
            alt: 'AI国补客户案例',
            title: '某知名 3C 数码品牌（3C 数码 / 手机）',
            desc: '全省约1500家品牌门店入驻千橙AI超级店长，已开单近600家，覆盖江苏全省主要地市。',
            stats: [
              { value: '1400万+', label: '国补销售额' },
              { value: '4700+', label: '订单数' },
              { value: '1500家', label: '入驻门店' }
            ]
          }
        },
        {
          title: 'AI 直播',
          color: '#8B5CF6',
          desc: '创建中央直播，网格员只需拉人进直播间即可实现销售转化与客户私域沉淀。支持数字人直播、智能内容生成、多平台一键分发，总部统一提供主播、场地、系统及运营方案。',
          stats: [
            { value: '600+', label: '连锁门店' },
            { value: '700场', label: '直播验证' },
            { value: '10万+', label: '商品池' }
          ],
          features: [
            { icon: 'video', title: '中央直播', desc: '总部统一搭建直播间，提供主播、场地、系统及运营方案' },
            { icon: 'monitor', title: '多店联播', desc: '门店与网格员仅需引流用户进入直播间，完成销售转化' },
            { icon: 'brain', title: '数字人直播', desc: 'AI 数字人 7×24 小时直播，降低直播成本，实现常态化运营' },
            { icon: 'package', title: '商品交付履约', desc: '10万+ 商品池，支持批采和 1 件代发，联合选品、统一履约' }
          ],
          caseStudy: {
            image: '/AI营销-客户案例-AI 直播.jpg',
            alt: 'AI直播客户案例',
            title: '某连锁零售品牌（连锁零售 / 健康）',
            desc: '通过直播电商产品，快速将全国近600家门店分散在微信群内的会员激活沉淀到系统中，举办了近700场直播。',
            stats: [
              { value: '200万', label: '沉淀会员' },
              { value: '6000万', label: '月带货订单' },
              { value: '700场', label: '直播场次' }
            ]
          }
        },
        {
          title: 'AI 社群',
          color: '#2563EB',
          desc: 'AI 社群机器人 + SaaS 工具，支持社群推广、会员营销、智能客服、自动推品卖货。针对有客户但缺系统化运营的私域需求企业，解决用户离店即失联的痛点，实现精细化运营。',
          stats: [
            { value: '7×24', label: '智能服务' },
            { value: '多行业', label: '场景覆盖' },
            { value: '高转化', label: '私域变现' }
          ],
          features: [
            { icon: 'sparkles', title: 'AI 社群机器人', desc: '7×24 小时智能客服，自动回复、主动触达、智能推荐' },
            { icon: 'target', title: '会员营销', desc: '用户分层运营，精准推送，会员体系搭建，提升复购率' },
            { icon: 'gift', title: '自动推品卖货', desc: '智能选品推荐，社群接龙，限时秒杀，自动成交转化' },
            { icon: 'bar-chart-3', title: '数据看板', desc: '社群活跃度、转化率、销售额等多维度数据实时监控' }
          ],
          caseStudy: {
            image: '/AI营销-客户案例-AI 社群.jpg',
            alt: 'AI社群客户案例',
            title: '区域老酒企（酒水 / 快消）',
            desc: 'AI社群运营赋能私域增长，社群月活率达65%，单店月均销量增长150%+，市场费用降低70%。',
            stats: [
              { value: '150%+', label: '销量增长' },
              { value: '65%', label: '社群月活' }
            ]
          }
        }
      ]
    }
  },
  methods: {
    openContact() {
      this.$root.$emit('openContactUs', 'AI效果营销')
    }
  }
}
</script>

<style scoped>
.aim-page {
  background: #fff;
  text-align: left;
}

/* ---------- Banner ---------- */
.banner-section {
  position: relative;
  overflow: hidden;
  background: #fff;
}
@media (min-width: 768px) {
  .banner-section {
    height: 600px;
  }
}
.banner-bg {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: none;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
@media (min-width: 768px) {
  .banner-bg {
    display: flex;
  }
}
.banner-bg-img {
  width: 1690px;
  height: 600px;
  object-fit: cover;
}
.banner-container {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  padding-top: 80px;
}
.banner-grid {
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
  width: 100%;
}
@media (min-width: 768px) {
  .banner-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 48px;
  }
}
.banner-title {
  font-size: 20px;
  font-weight: 700;
  color: #0a0a0a;
  line-height: 1.2;
  margin: 0 0 12px;
}
.banner-subtitle {
  font-size: 22px;
  font-weight: 700;
  color: #0a0a0a;
  line-height: 1.2;
  margin: 0 0 20px;
}
.banner-desc {
  font-size: 13px;
  color: #666666;
  line-height: 1.625;
  margin: 0 0 24px;
  max-width: 560px;
}
@media (min-width: 768px) {
  .banner-title {
    font-size: 44px;
  }
  .banner-subtitle {
    font-size: 56px;
  }
  .banner-desc {
    font-size: 15px;
  }
}
.banner-image-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.banner-image {
  width: 100%;
  height: auto;
  max-height: 300px;
  object-fit: contain;
}
@media (min-width: 768px) {
  .banner-image {
    max-height: none;
  }
}

/* ---------- 通用按钮 ---------- */
.cta-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 20px;
  font-size: 15px;
  font-weight: 500;
  border-radius: 8px;
  background: #000;
  color: #fff;
  width: 160px;
  overflow: hidden;
  text-decoration: none;
  transition: all 0.3s;
}
@media (min-width: 768px) {
  .cta-btn {
    width: 180px;
    font-size: 16px;
  }
  .cta-btn-lg {
    padding: 12px 24px;
  }
}
.cta-btn-text {
  transition: transform 0.3s ease-out;
}
.cta-btn:hover .cta-btn-text {
  transform: translateX(-4px);
}
.cta-btn-arrow {
  position: absolute;
  right: 24px;
  opacity: 0;
  transform: translateX(8px);
  transition: all 0.3s ease-out;
}
.cta-btn:hover .cta-btn-arrow {
  opacity: 1;
  transform: translateX(0);
}

/* ---------- 通用区块标题 ---------- */
.section-head {
  text-align: center;
  margin-bottom: 48px;
}
@media (min-width: 768px) {
  .section-head {
    margin-bottom: 64px;
  }
}
.section-title {
  font-size: 22px;
  font-weight: 700;
  color: #0a0a0a;
  margin: 0 0 12px;
}
.section-desc {
  font-size: 13px;
  color: #666666;
  text-align: center;
  margin: 0;
}
@media (min-width: 768px) {
  .section-title {
    font-size: 36px;
  }
  .section-desc {
    font-size: 16px;
  }
}

/* ---------- 四大AI场景能力矩阵 ---------- */
.matrix-section {
  padding: 64px 0;
  background: #f9fafb;
}
@media (min-width: 768px) {
  .matrix-section {
    padding: 112px 0;
  }
}
.matrix-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}
@media (min-width: 768px) {
  .matrix-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.matrix-grid > .animated-section {
  height: 100%;
}
.matrix-card {
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 24px;
}
@media (min-width: 768px) {
  .matrix-card {
    padding: 32px;
  }
}
.matrix-text {
  flex: 1;
  min-width: 0;
}
.matrix-title {
  font-size: 22px;
  font-weight: 700;
  color: #0a0a0a;
  margin: 0 0 12px;
}
@media (min-width: 768px) {
  .matrix-title {
    font-size: 24px;
  }
}
.matrix-desc {
  font-size: 16px;
  color: #333333;
  line-height: 1.625;
  margin: 0 0 16px;
}
.matrix-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.matrix-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: #f5f5f5;
  color: #0a0a0a;
  font-size: 14px;
  border-radius: 9999px;
}
.matrix-image-wrap {
  flex-shrink: 0;
}
.matrix-image-box {
  width: 100px;
  height: 100px;
  border-radius: 16px;
  overflow: hidden;
}
@media (min-width: 768px) {
  .matrix-image-box {
    width: 120px;
    height: 120px;
  }
}
.matrix-image-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* ---------- 解决方案详情 ---------- */
.solution-section {
  padding: 64px 0;
  background: #fff;
}
@media (min-width: 768px) {
  .solution-section {
    padding: 112px 0;
  }
}
.solution-block {
  margin-bottom: 96px;
}
.solution-block-last {
  margin-bottom: 0;
}
.solution-head {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 40px;
}
@media (min-width: 768px) {
  .solution-head {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}
.solution-title {
  font-size: 22px;
  font-weight: 700;
  color: #0a0a0a;
  margin: 0 0 16px;
}
@media (min-width: 768px) {
  .solution-title {
    font-size: 32px;
  }
}
.solution-desc {
  font-size: 16px;
  color: #666666;
  max-width: 600px;
  line-height: 1.625;
  margin: 0;
}
.solution-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  flex-shrink: 0;
  text-align: right;
}
.solution-stat-value {
  font-size: 28px;
  font-weight: 700;
}
.solution-stat-label {
  font-size: 13px;
  color: #666666;
}

/* 特性卡片 */
.feature-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 32px;
}
@media (min-width: 768px) {
  .feature-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
.feature-grid > .animated-section {
  height: 100%;
}
.feature-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 20px;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  height: 100%;
}
.feature-icon {
  margin-top: 2px;
  flex-shrink: 0;
}
.feature-text {
  flex: 1;
  min-width: 0;
}
.feature-text h3 {
  font-size: 15px;
  font-weight: 600;
  color: #0a0a0a;
  margin: 0 0 4px;
}
.feature-text p {
  font-size: 14px;
  color: #666666;
  line-height: 1.625;
  margin: 0;
}

/* 渠道卡片（AI 获客） */
.channel-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-bottom: 40px;
}
@media (min-width: 768px) {
  .channel-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.channel-card {
  padding: 24px;
  border-radius: 12px;
  height: 100%;
}
.channel-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.channel-head img {
  width: 28px;
  height: 28px;
  object-fit: contain;
}
.channel-head h3 {
  font-size: 18px;
  font-weight: 700;
  color: #0a0a0a;
  margin: 0;
}
.channel-card p {
  font-size: 14px;
  color: #666666;
  line-height: 1.625;
  margin: 0;
}

/* 客户案例 */
.case-card {
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 32px;
  background: #fafafa;
  border-radius: 16px;
}
@media (min-width: 768px) {
  .case-card {
    flex-direction: row;
  }
}
.case-image-wrap {
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 12px;
  flex-shrink: 0;
  overflow: hidden;
}
@media (min-width: 768px) {
  .case-image-wrap {
    width: 360px;
  }
}
.case-image-wrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.case-body {
  flex: 1;
  min-width: 0;
}
.case-label {
  font-size: 16px;
  font-weight: 400;
  color: #0a0a0a;
  margin: 0 0 20px;
}
.case-main {
  margin-bottom: 20px;
}
.case-title {
  font-size: 20px;
  font-weight: 600;
  color: #0a0a0a;
  margin: 0 0 12px;
}
.case-desc {
  font-size: 14px;
  color: #666666;
  line-height: 1.625;
  margin: 0;
}
.case-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}
.case-stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #0a0a0a;
}
.case-stat-label {
  font-size: 14px;
  color: #666666;
  margin-left: 8px;
}

/* ---------- CTA ---------- */
.cta-section {
  height: 400px;
  background: #eef0f6;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cta-bg {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.cta-bg-img {
  width: 1600px;
  height: 400px;
  object-fit: cover;
  object-position: center;
}
.cta-content {
  text-align: center;
  position: relative;
  z-index: 10;
}
.cta-title {
  font-size: 22px;
  font-weight: 700;
  color: #0a0a0a;
  margin: 0 0 12px;
}
.cta-desc {
  font-size: 13px;
  color: #666666;
  text-align: center;
  margin: 0;
}
@media (min-width: 768px) {
  .cta-title {
    font-size: 36px;
  }
  .cta-desc {
    font-size: 16px;
  }
}
.cta-btn-wrap {
  margin-top: 24px;
}
@media (min-width: 768px) {
  .cta-btn-wrap {
    margin-top: 32px;
  }
}

/* ---------- 容器 ---------- */
.container-responsive {
  width: 100%;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-left: 1rem;
  padding-right: 1rem;
}
@media (min-width: 768px) {
  .container-responsive {
    padding-left: 4rem;
    padding-right: 4rem;
  }
}
@media (min-width: 1200px) {
  .container-responsive {
    max-width: 1400px;
  }
}
@media (min-width: 1600px) {
  .container-responsive {
    max-width: 1600px;
  }
}
@media (min-width: 1920px) {
  .container-responsive {
    max-width: 1800px;
  }
}
</style>
